/* PK - videos produit facon GIF (autoplay muet, boucle, sans controles), mobile-safe.
   - ne charge/joue que la video visible (IntersectionObserver)
   - met en pause hors champ
   - n'observe que la galerie produit (pas tout le document)
   - videos Shopify-hostees uniquement (les iframes YouTube/Vimeo restent en tap-to-play) */
(function () {
  if (window.__pkVideoInit) return;
  window.__pkVideoInit = true;

  function tune(v) {
    if (!v) return;
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.loop = true; v.setAttribute('loop', '');
    v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.controls = false; v.removeAttribute('controls');
    v.style.touchAction = 'pan-y';
    v.style.pointerEvents = 'none';
  }

  function isNativeVideo(dm) {
    var tpl = dm.querySelector('template');
    return (tpl && /<video/i.test(tpl.innerHTML)) || !!dm.querySelector('video');
  }

  function loadAndPlay(dm) {
    if (!isNativeVideo(dm)) return;
    if (!dm.getAttribute('loaded') && typeof dm.loadContent === 'function') {
      try { dm.loadContent(false); } catch (e) {}
    }
    var v = dm.querySelector('video');
    if (v) { tune(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var dm = entry.target;
      if (entry.isIntersecting) { loadAndPlay(dm); }
      else { var v = dm.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } }
    });
  }, { threshold: 0.25 }) : null;

  function register(dm) {
    if (!isNativeVideo(dm) || dm.__pkObserved) return;
    dm.__pkObserved = true;
    dm.classList.add('pk-video');
    var container = dm.closest('.product-media-container');
    if (container) container.classList.add('pk-has-video');
    if (io) { io.observe(dm); } else { loadAndPlay(dm); }
  }

  function scan(root) {
    (root || document).querySelectorAll('.product-media-container deferred-media').forEach(register);
  }

  function start() {
    scan(document);
    document.querySelectorAll('media-gallery').forEach(function (g) {
      new MutationObserver(function () { scan(g); }).observe(g, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
